var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"socContent"},[(_vm.verifiedSoc)?_c('verified-soc',{attrs:{"soc":_vm.data},on:{"remove":_vm.selfDestruct}}):_c('not-verified-soc',{attrs:{"suborder":_vm.data.suborder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }